import { Module } from "@/constants";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import * as configs from "@/containers/dictionaries/configs";
import { ReadonlyObject } from "@/types/readOnly";

export const getDictionaryConfig = <
  TRead extends ReadonlyObject,
  TWrite extends object,
>(
  dict: Module,
): DictionaryConfig<TRead, TWrite> => {
  const configObjects = Object.values(configs).reduce(
    (acc, config) => {
      acc[config.id] = config as unknown as DictionaryConfig<TRead, TWrite>;
      return acc;
    },
    {} as Record<Module, DictionaryConfig<TRead, TWrite>>,
  );

  return configObjects[dict];
};
